import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AnimatePresence, motion } from 'framer-motion'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import styled from 'styled-components'
import { ReactComponent as CloseIcon } from '~/assets/images/close-gray.svg'

export const activityId = 'staking-by-lido-activity-20250709-visited'

const Activity = () => {
  const { t } = useTranslation()
  const [cache, setCache] = useLocalStorage(activityId, false)
  const [visible, setVisible] = useState(!cache)
  const variants = {
    open: { opacity: 1 },
    close: { opacity: 0, transitionEnd: { height: 0, padding: 0, margin: 0 } },
  }

  const handleGo = () => {
    if (window.location.pathname === '/staking') {
      return
    }
    window.location.href = `${window.location.origin}/staking`
  }

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation()
    setVisible(false)
    setCache(true)
  }

  return (
    <AnimatePresence initial={!cache}>
      <Wrapper
        animate={visible ? 'open' : 'close'}
        variants={variants}
        onClick={handleGo}
      >
        <Content>
          <Title>{t('activity_title')}</Title>
          <Description>{t('activity_desc')}</Description>
        </Content>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
      </Wrapper>
    </AnimatePresence>
  )
}

const Wrapper = styled(motion.div)`
  position: relative;
  width: 100%;
  max-width: 435px;
  margin-bottom: 16px;
  padding: 16px 12px 24px 12px;
  border-radius: 16px;
  background: #ebedff;
  cursor: pointer;
`

const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

const Title = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #222226;
`

const Description = styled.p`
  margin: 0 !important;
  margin-top: 8px !important;
  font-size: 13px;
  font-weight: 300;
  line-height: 20px;
  color: #222226;
`

const CloseButton = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
`

export default Activity
